"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADVANCED_INVENTORY_MANAGEMENT = void 0;
var ADVANCED_INVENTORY_MANAGEMENT = {
  ROW__PRODUCT: 'advancedInventoryManagement-tr-product',
  INPUT__CHECKBOX: 'advancedInventoryManagement-input-checkbox',
  IMG__PRODUCT: 'advancedInventoryManagement-div-productImage',
  INPUT__QUANTITY: 'advancedInventoryManagement-input-quantity',
  TEXT__TOOLTIP: {
    CONTAINER: 'advancedInventoryManagement-value-tooltipContainer',
    PRODUCT: 'advancedInventoryManagement-value-tooltipProductName',
    LOCATION: 'advancedInventoryManagement-value-tooltipLocation',
    BATCH_CODE: 'advancedInventoryManagement-value-tooltipBatchCode',
    COGS: 'advancedInventoryManagement-value-tooltipCOGS'
  }
};
exports.ADVANCED_INVENTORY_MANAGEMENT = ADVANCED_INVENTORY_MANAGEMENT;